import { Button } from "@/components/ui/button";
import { Globe } from "lucide-react";

interface MarketFilterProps {
  selectedMarket: 'de' | 'en';
  onMarketChange: (market: 'de' | 'en') => void;
  projectCount?: number;
  className?: string;
}

export const MarketFilter = ({ 
  selectedMarket, 
  onMarketChange, 
  projectCount,
  className = "" 
}: MarketFilterProps) => {
  return (
    <div className={`flex flex-col items-center gap-4 ${className}`}>
      <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/10 text-primary text-sm">
        <Globe className="w-4 h-4" />
        <span>Projekte nach Zielmarkt</span>
      </div>
      
      <div className="flex flex-wrap gap-3 justify-center">
        <Button
          variant={selectedMarket === 'de' ? 'default' : 'outline'}
          size="default"
          onClick={() => onMarketChange('de')}
          className="gap-2 min-w-[140px]"
        >
          <span className="text-base">🇩🇪</span>
          <span>DACH-Region</span>
        </Button>
        
        <Button
          variant={selectedMarket === 'en' ? 'default' : 'outline'}
          size="default"
          onClick={() => onMarketChange('en')}
          className="gap-2 min-w-[140px]"
        >
          <span className="text-base">🇬🇧</span>
          <span>International</span>
        </Button>
      </div>
      
      <p className="text-sm text-muted-foreground text-center">
        {selectedMarket === 'de' && 'Zeige Projekte für den deutschen & DACH-Markt'}
        {selectedMarket === 'en' && 'Zeige internationale Projekte (inkl. Englisch, Arabisch, etc.)'}
        {projectCount !== undefined && (
          <>
            <span className="mx-2">•</span>
            <span className="font-semibold">{projectCount}</span>
            {' '}{projectCount === 1 ? 'Projekt' : 'Projekte'}
          </>
        )}
      </p>
    </div>
  );
};